/**
 * ZipCodeInactiveCard.js
 *
 * A card displayed when a ZIP code is entered that is NOT in an active CommunityShare community.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { RocketLaunchIcon } from '@heroicons/react/24/solid';

/**
 * Displays a message for a community that is not yet active.
 *
 * @param {object} props - Component props.
 * @param {string} props.city - The city name.
 * @param {string} props.state - The state name.
 * @returns {JSX.Element} The rendered inactive card.
 */
export default function ZipCodeInactiveCard(props) {
  const { city, state } = props;
  return (
    <div className="flex gap-2 items-start bg-cs-blue-100 border border-cs-blue-500 rounded-2xl px-4 pt-4 pb-5">
      <RocketLaunchIcon className="size-5 shrink-0 text-cs-blue-500 mt-0.5" />
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-4">
          <p className="text-base font-semibold leading-snug text-cs-gray-900">
            CommunityShare is just getting started in {city || 'your area'}{state ? `, ${state}` : ''}
          </p>
        </div>
        <p className="text-base leading-snug text-cs-gray-900">
          You&apos;re one of the first to sign up. We&apos;re excited to connect you as opportunities and partners begin to emerge near you.
        </p>
      </div>
    </div>
  );
}

ZipCodeInactiveCard.propTypes = {
  city: PropTypes.string,
  state: PropTypes.string,
};
